<template>
  <div class="container">
    <div class="finance-content-body">
      <div class="title">账号基本信息</div>
      <div class="base-info">
        <p>
          <span>订单号：159599331000002</span>
        </p>
        <p>
          <span>创建时间：2020-07-29 11:28:08</span>
        </p>
        <p>
          <span>学员姓名：李旸</span>
        </p>
        <p>
          <span>手机号：18722160682</span>
        </p>
        <p>
          <span>订单状态：已支付</span>
        </p>
        <p>
          <span>支付方式：线下支付</span>
        </p>
        <p>
          <span>支付渠道：--</span>
        </p>
        <p>
          <span>支付时间：2020-07-29 11:28:08</span>
        </p>
        <p>
          <span>订单总价：0.00</span>
        </p>
        <p>
          <span>收款人：演示账号</span>
        </p>
        <p>
          <span>备注：xxxxxxxxxxxxxxxxxxxxxxxxx</span>
        </p>
      </div>
      <div class="title">商品信息</div>
      <div class="base-table">
        <el-table :data="goodsTableData" border style="width: 100%">
          <el-table-column prop="productTypeStr" label="商品类目">
          </el-table-column>
          <el-table-column prop="goodsName" label="商品名称"> </el-table-column>
          <el-table-column prop="unitPrice" label="单价"> </el-table-column>
          <el-table-column prop="goodsNum" label="数量"> </el-table-column>
          <el-table-column prop="goodsTotal" label="商品总价">
          </el-table-column>
          <el-table-column prop="discountMoney" label="直减优惠">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "financeContent",
  data() {
    return {
      goodsTableData: [
        {
          productTypeStr: "课程-长期课",
          goodsName: "数学暑三思维突破",
          unitPrice: 2499,
          goodsNum: 1,
          goodsTotal: 2499,
          discountMoney: 2499,
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow: hidden;
  .finance-content-body {
    margin: 20px;
    padding: 20px;
    background-color: #ffffff;
    .title {
      font-size: 14px;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 10px;
    }
    .base-info {
      font-size: 14px;
      margin-top: 20px;
      margin-left: 20px;
      p {
        margin-bottom: 10px;
      }
      margin-bottom: 30px;
    }
    .base-table {
      margin-top: 20px;
      margin-left: 20px;
    }
  }
}
</style>
